import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { NAV_PLACEMENT } from 'src/enums/navigation';
import { THEME } from 'src/enums/theme';
import ChevronRightIcon from 'src/icons/chevron-right.svg';

import styles from './SubNavSidebarCta.module.scss';

interface SubNavSidebarCtaProps {
  href: string;
  text: string;
  placement: NAV_PLACEMENT;
  theme?: THEME;
  isSecondaryColor?: boolean;
}

/**
 * A call-to-action button styled to match PrimaryButton from the theme.
 * Uses a plain <a> tag since the trim project does not include react-router-dom.
 */
export const SubNavSidebarCta: FunctionComponent<SubNavSidebarCtaProps> = ({
  href,
  text,
  placement,
  theme = THEME.LIGHT,
  isSecondaryColor = false,
}) => {
  const isDeviceSubNav = placement === NAV_PLACEMENT.DEVICE_SUB_NAV;

  return (
    <a
      className={classNames(styles.ctaButton, styles[theme], {
        [styles.deviceSubNav]: isDeviceSubNav,
        [styles.secondaryColor]: isSecondaryColor,
      })}
      href={href}
    >
      <span className={styles.labelWrapper}>
        <span className={styles.label}>{text}</span>
        <span aria-hidden className={styles.secondaryLabel}>
          {text}
        </span>
      </span>
      {/* Two chevrons stacked: first slides out, second slides in on hover */}
      <span className={styles.chevronWrapper}>
        <ChevronRightIcon className={styles.chevronIcon} />
        <ChevronRightIcon className={classNames(styles.chevronIcon, styles.chevronSecondary)} aria-hidden />
      </span>
    </a>
  );
};
